module.exports = __webpack_public_path__ + "img/Acmi_7.aab23b3a.gif";